var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7589 5.22636C13.0803 5.52689 13.0803 6.01832 12.7589 6.32014L6.92932 11.773C6.76865 11.9239 6.55856 12 6.34708 12C6.13697 12 5.92682 11.9239 5.76614 11.773L3.24204 9.42346C2.91932 9.12293 2.91932 8.63151 3.24204 8.32969C3.56339 8.02787 4.08387 8.02787 4.40522 8.32969L6.34708 10.1311L11.5944 5.22636C11.9157 4.92455 12.4362 4.92455 12.7589 5.22636Z",
    fill: "#151514"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.158b0163.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7589 5.22636C13.0803 5.52689 13.0803 6.01832 12.7589 6.32014L6.92932 11.773C6.76865 11.9239 6.55856 12 6.34708 12C6.13697 12 5.92682 11.9239 5.76614 11.773L3.24204 9.42346C2.91932 9.12293 2.91932 8.63151 3.24204 8.32969C3.56339 8.02787 4.08387 8.02787 4.40522 8.32969L6.34708 10.1311L11.5944 5.22636C11.9157 4.92455 12.4362 4.92455 12.7589 5.22636Z",
    fill: "#151514"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.158b0163.svg";
export { ForwardRef as ReactComponent };